import { all, put, takeEvery, call, select } from "redux-saga/effects";
import { GROUPS_ACTIONS, GROUPS_TYPES } from "./actions";
import {
  getGroups,
  updateGroup as APIupdateGroup,
  createGroup as APIcreateGroup,
  deleteGroup as APIdeleteGroup
} from "../../services/api/permissionPresets";
import { createNavigateTo } from "../navigation/saga";
import { groupsFilters } from "./selectors";

export function* watchGroupsActions() {
  yield all([takeEvery(GROUPS_TYPES.CREATE_REQUEST, createGroup)]);
  yield all([takeEvery(GROUPS_TYPES.LOAD_ALL_REQUEST, loadGroups)]);
  yield all([takeEvery(GROUPS_TYPES.UPDATE_FILTERS, loadGroups)]);
  yield all([takeEvery(GROUPS_TYPES.UPDATE_REQUEST, updateGroup)]);
  yield all([takeEvery(GROUPS_TYPES.DELETE_REQUEST, deleteGroup)]);
  yield all([
    takeEvery(GROUPS_TYPES.UPDATE_SUCCESS, createNavigateTo("/admin/groups"))
  ]);
  yield all([
    takeEvery(GROUPS_TYPES.CREATE_SUCCESS, createNavigateTo("/admin/groups"))
  ]);
}

function* loadGroups(action) {
  try {
    const filters = yield select(groupsFilters);
    const groups = yield call(getGroups, filters);
    yield put(GROUPS_ACTIONS.loadAllSuccess(groups));
  } catch (e) {
    yield put(GROUPS_ACTIONS.loadAllFailure(e));
  }
}

function* updateGroup(action) {
  try {
    const { id, values } = action.payload;
    const group = yield call(APIupdateGroup, id, values);
    yield put(GROUPS_ACTIONS.updateSuccess(group));
  } catch (e) {
    yield put(GROUPS_ACTIONS.updateFailure(e));
  }
}

function* createGroup(action) {
  try {
    const { values } = action.payload;
    const group = yield call(APIcreateGroup, values);
    yield put(GROUPS_ACTIONS.createSuccess(group));
  } catch (e) {
    yield put(GROUPS_ACTIONS.createFailure(e));
  }
}

function* deleteGroup(action) {
  try {
    const { id } = action.payload;
    const group = yield call(APIdeleteGroup, id);
    yield put(GROUPS_ACTIONS.deleteSuccess(group));
    yield put(GROUPS_ACTIONS.loadAllRequest());
  } catch (e) {
    yield put(GROUPS_ACTIONS.deleteFailure(e));
  }
}
